var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TransitionWrapper',_vm._g({class:['bubble-face', ("is-color-" + _vm.color)],attrs:{"auto-hide":_vm.duration}},_vm.$listeners),[_c('div',{staticClass:"shape"}),(_vm.label)?_c('p',[_vm._v(_vm._s(_vm.label))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }